import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/Reveal";
import { ASSETS } from "@/data/site";

export default function CommunityBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[75vh] overflow-hidden lg:h-[85vh]" data-testid="community-band">
      <motion.div style={{ y }} className="absolute inset-0 -top-[15%] -bottom-[15%]">
        <img
          src={ASSETS.community}
          alt="Many hands of a community holding a pregnant belly"
          className="h-full w-full object-cover"
          data-testid="community-band-image"
        />
      </motion.div>
      <div className="absolute inset-0 bg-espresso/55" />
      <div className="relative z-10 mx-auto flex h-full max-w-7xl items-end px-6 pb-20 lg:px-10">
        <div className="max-w-3xl">
          <FadeUp>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-mauve">
              It takes a village
            </p>
            <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-ivory sm:text-5xl lg:text-6xl" data-testid="community-band-title">
              No mother was ever meant to <span className="italic text-mauve">do this alone</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory/75">
              Every hand in this circle is someone who has learned to hold her. In our
              gathering, your people — partner, grandmother, auntie, dear friend — become
              fluent in the ancestral language of care.
            </p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
